import React, { Suspense } from 'react';
import { CircularProgress } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { clsxm } from '@app/styles/clsxm';
import { ReactComponent as Logo } from '@app/assets/images/app-logo.svg';
import BackgroundImage from './assets/auth-background.jpg';

export const AuthModule = () => {
  return (
    <div className="flex h-full min-h-screen flex-col justify-between">
      <img
        src={BackgroundImage}
        className={clsxm('absolute -z-10 h-full w-full object-cover', 'md:h-screen md:pr-[500px]')}
        alt="Logo img"
      />
      <div className="flex items-center space-x-3 p-14 md:absolute md:left-12 md:top-10 md:z-20 md:p-0">
        <Logo />
      </div>
      <div
        className={clsxm('z-10 flex w-full items-center', 'md:absolute md:right-0 md:top-14 md:bottom-14 md:w-[600px]')}
      >
        <div
          className={clsxm(
            'flex h-full w-full items-center rounded-t-[40px] border border-solid border-gray-100 bg-white px-14 py-16 shadow-card',
            'md:my-16 md:rounded-l-[40px] md:rounded-tr-none md:px-24 md:py-16'
          )}
        >
          <Suspense fallback={<CircularProgress size={48} className="mx-auto" />}>
            <div className="flex h-full w-full items-center overflow-auto">
              <Outlet />
            </div>
          </Suspense>
        </div>
      </div>
    </div>
  );
};
